import { makeAutoObservable } from "mobx";
import moment from "moment";
import dayjs from "dayjs";
import { toastMsg } from "../../utilities/helpers/ToastHelper";
import { reservationService } from "./ReservationService";

class ReservationState{
  reservationName: string = '';
  reservationPhoneNumber: string = '';
  reservationHour: string = '';
  reservationDate: string = '';
  reservationPeopleAmount: number = 0;
  reservationNote: string = '';
  modalOpenStatus: boolean = false;
  constructor(){
      makeAutoObservable(this)
  }
  disablePastTimeAntd(current:any){
    const now = moment();
    return {
      disabledHours: () => {
        // Vô hiệu hóa tất cả các giờ trước giờ hiện tại
        const currentHour = now.hour();
        return Array.from({ length: 24 }, (_, i) => (i < currentHour ? i : null)).filter((hour) => hour !== null) as number[];
      },
      disabledMinutes: (selectedHour:any) => {
        const currentHour = now.hour();
        const currentMinute = now.minute();

        if (selectedHour < currentHour) {
          // Nếu giờ đã qua, disable tất cả phút
          return Array.from({ length: 60 }, (_, i) => i);
        } else if (selectedHour === currentHour) {
          // Nếu là giờ hiện tại, chỉ cho phép chọn phút hợp lệ dựa trên phút hiện tại
          if (currentMinute >= 30) {
            // Nếu phút hiện tại >= 30, chỉ cho phép chọn phút sau 30 phút
            return Array.from({ length: 60 }, (_, i) => (i < 30 ? i : null)).filter((minute) => minute !== null) as number[];
          } else {
            // Nếu phút hiện tại < 30, chỉ cho phép chọn phút sau phút hiện tại
            return Array.from({ length: 60 }, (_, i) => (i < currentMinute || (i !== 0 && i !== 30) ? i : null)).filter((minute) => minute !== null) as number[];
          }
        } else {
          // Nếu là giờ tương lai, chỉ cho phép chọn 00 và 30 phút
          return Array.from({ length: 60 }, (_, i) => (i !== 0 && i !== 30 ? i : null)).filter((minute) => minute !== null) as number[];
        }
      },
    };
  };
  disablePastDates(current:any){
    return current && current < dayjs().startOf('day')
  }
  async handleFormSending(){
    // handle input
    const reservationData = {
      name: this.reservationName,
      phone_number: this.reservationPhoneNumber,
      time_date: `${this.reservationHour}, ${this.reservationDate}`,
      people_amount: this.reservationPeopleAmount,
      note: this.reservationNote,
    }
    const {data, error} = await reservationService.submitReservation(reservationData);
    this.modalOpenStatus = false
    if(error){
      toastMsg.error(`${error}`, '');
    }
    else{
      toastMsg.success(`Đặt bàn thành công!`, '');
    }
  }
  handleCloseConfirmModal(){
    this.modalOpenStatus = false;
  }
  handleShowConfirmModal(){
    if(this.reservationPhoneNumber.length !== 10){
      toastMsg.error('Số điện thoại không hợp lệ!', '');
      return -1;
    }
    this.modalOpenStatus = true;
  }
}
export const reservationState = new ReservationState()